import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { logAPIError } from '../../../utils/logger';

const ERROR_MESSAGE = 'Failed to save order enrichment';
const saveEnrichmentByPaymentSession = async ({ paymentSessionId, mixpanelEnrichment = {} }) => {
    const requestUrl = pathfinder('logo_maker_buyer_ajax', { endpoint: 'saveMixpanelGlobalProps' });
    const key = `logo_maker::payment_session_enrichment::${paymentSessionId}`;

    try {
        const { data } = await axios.post(requestUrl, { key, mixpanelEnrichment });
        return data;
    } catch (error) {
        logAPIError(error, { message: ERROR_MESSAGE, paymentSessionId });
    }
};

export default saveEnrichmentByPaymentSession;
